module.exports = __webpack_public_path__ + "static/media/boxing-icon.5320ba2f.webp";